import startCase from 'lodash/startCase';
import upperFirst from 'lodash/upperFirst';

import { Block } from '@eluve/llm-outputs';

const convertBlockGroup = (blocks: Block[]): string => {
  const finalMarkdown: string[] = [];
  for (const block of blocks) {
    const header = upperFirst(startCase(block.label));
    finalMarkdown.push(`# ${header}\n\n`);
    if (block.type === 'text' && block.text) {
      finalMarkdown.push(block.text + '\n\n');
    }
    if (block.type === 'group' && block.blocks.length) {
      const groupMarkdown = convertBlockGroup(block.blocks);
      finalMarkdown.push(groupMarkdown);
    }
  }

  return finalMarkdown.join('');
};

export const convertBlocksToMarkdown = (block: Block): string => {
  if (block.type === 'text' && block.text) {
    return block.text;
  }
  if (block.type === 'group' && block.blocks.length) {
    return convertBlockGroup(block.blocks);
  }
  return '';
};
